import NotificationDispatcher from "../core/notification-dispatcher/NotificationDispatcher";
import { NotificationType } from "../core/notification-dispatcher/Notification";

const notify = (notificationDispatcher: NotificationDispatcher): Notify => (message, type) => {
    notificationDispatcher.dispatch({
        message,
        type: type || NotificationType.INFO
    });
}
export default notify;

export type Notify = (message: string, type?: NotificationType) => void;